import { FIXED, MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
// form fields
// import { PostChangeCommsLabel } from 'AppSrc/core/components/forms/form-types/completion-review/section-three/post-change-comms-label';
import { postChangeCommsSelector, summaryDisplayOptions } from './post-change-comms-selector';
// sub section titles
import { postChangeComms } from './post-change-comms';
import { paragraphPostChangeComms } from './paragraph';
import { paragraphOLO } from './paragraph-olo';

const getInitialValue = ({ network, isOLO }) => {
  if (isOLO) {
    if (network === MOBILE) {
      return 'Successful';
    }
    if (network === FIXED) {
      return '5000';
    }
  }
  return null;
};
// const filterAndSortImpact = (options, statusReason) => {
//   console.log('options', options, statusReason);
//   if (statusReason === '6200') {
//     const isunsuccessful = options.find((option) => (option.value === '6200' || option.value === 'Unsuccessful'));
//     console.log('isunsuccessful', isunsuccessful);
//     return [isunsuccessful];
//   }
//   if (statusReason === undefined) {
//     return options;
//   }
//   if (statusReason === '5000') {
//     const Successful = options.find((option) => (option.value === '5000' || option.value === 'Successful'));
//     console.log('Successful', Successful);
//     return [Successful];
//   }
//   if (statusReason === 'Unsuccessful') {
//     const isunsuccessful = options.find((option) => (option.value === 'Unsuccessful'));
//     console.log('isunsuccessful', isunsuccessful);
//     return [isunsuccessful];
//   }
//   if (statusReason === 'Successful') {
//     const isunsuccessful = options.find((option) => (option.value === 'Successful'));
//     console.log('isunsuccessful', isunsuccessful);
//     return [isunsuccessful];
//   }
//   return options;
// };
// callback for the form section to figure out what fields to render with conditional logic
const getSectionThreeCurrentFields = ({ network, isOLO, statusReason } = {}) => {
  const currentFields = [
    {
      ...defaultFieldLogic,
      componentData: postChangeComms,
    },
    {
      ...defaultFieldLogic,
      componentData: isOLO ? paragraphOLO : paragraphPostChangeComms,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...postChangeCommsSelector,
        displayOptions: summaryDisplayOptions[network],
        initialValues: getInitialValue({ network, isOLO }),
      },
    },
  ];
  return currentFields;
};

export {
  getSectionThreeCurrentFields,
};
